import { Button, H3 as BaseH3, H4 as BaseH4, Text as BaseText } from '@commonsku/styles';
import React from 'react';
import styled from 'styled-components';

const DEMO_URL = 'https://commonsku.com/demo';

const CollectionsPanelContainer = styled.div`
    &&& {
        display: flex;
        flex-direction: column;
        margin: 36px;
        padding: 36px;
        background-color: #beebf3;
        border-radius: 5px;
        box-shadow: 0 4px 8px rgba(0, 113, 206, 0.1);
        -webkit-box-shadow: 0 4px 8px rgba(0, 113, 206, 0.1);
        gap: 16px;
    }
`;

const HeadingBlock = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
`;

const DemoButton = styled(Button)`
    &&& {
        width: fit-content;
        margin-top: 16px;
    }
`;

const H3 = styled(BaseH3)`
    &&& {
        color: #005479;
        font-size: 1.75rem;
        font-weight: 500;
        line-height: 2.25rem;
        margin-bottom: 0;
    }
`;

const H4 = styled(BaseH4)`
    &&& {
        color: #00799B;
        font-size: 1.5rem;
        font-weight: 500;
        line-height: 2rem;
        margin-bottom: 0;
    }
`;

const List = styled.ul`
    &&& {
        margin-bottom: 0;
    }
`;

const Text = styled(BaseText)`
    &&& {
        font-family: "skufont-regular", sans-serif;
        color: #2a4d63;
    }
`;

export const CollectionsPanel = () => {
    return (
        <CollectionsPanelContainer>
            <H3>Not a commonsku customer yet?</H3>
            <HeadingBlock>
                <H4>What is commonsku?</H4>
                <Text>commonsku is a software platform built by and for promotional products pros, giving distributors the tools, integrations, and supplier network they need to automate the busywork and stay focused on what matters: big ideas, better client experiences, and growing their business.</Text>
            </HeadingBlock>
            <HeadingBlock>
                <H4>Why join commonsku?</H4>
                <Text>
                    If you're exploring The Backpack, you're already trend-forward. commonsku helps you bring those trends to life:
                </Text>
                <Text>
                    <List>
                        <li>Build beautiful client presentations fast</li>
                        <li>Collaborate with suppliers and clients in real time</li>
                        <li>Automate product sourcing, quoting, mockups, and more</li>
                        <li>Track sales, margins, and production — all in one place</li>
                    </List>
                </Text>
            </HeadingBlock>
            <HeadingBlock>
                <H4>Curious how it works?</H4>
                <Text>Join hundreds of promo companies who've transformed the way they work.</Text>
            </HeadingBlock>
            <DemoButton
                variant="cta"
                onClick={() => window.open(DEMO_URL, '_blank')}
            >
                Book a Demo
            </DemoButton>
        </CollectionsPanelContainer>
    );
}
